import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const lgaBaseEndpoint = ENDPOINTS.LGA;

// States API
export const lgaApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["lgas"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getLGAs: builder.query({
        query: (payload) => `${lgaBaseEndpoint}?state_id=${payload}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "lgas" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
    }),
  });

// Export hooks for usage in components

export const { useGetLGAsQuery } = lgaApi;
